import { z } from 'zod/v4';
import { DocumentTypes } from '../../documents/index.js';
import { PerformedBySchema } from '../../performed-by/index.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
import { searchEnvelopeSchema, searchInputSchema } from './envelope.js';
const filtersSchema = z.object({
    types: z.array(z.enum(DocumentTypes)).optional(),
    foundation: z
        .boolean()
        .optional()
        .describe('true = only foundations; false = only non-foundations; omit for both.'),
    signed: z
        .boolean()
        .optional()
        .describe('true = only signed documents; false = only unsigned; omit for both.'),
});
const itemSchema = z.object({
    documentId: z.uuid(),
    fileId: z.uuid(),
    fileName: z.string(),
    contentType: z
        .string()
        .describe('MIME type. Use this to decide if file text extraction is likely to succeed.'),
    type: z.enum(DocumentTypes),
    date: z.iso.datetime().nullable(),
    signedAt: z.iso.datetime().nullable(),
    isFoundation: z.boolean(),
    sizeBytes: z.number().int().nullable(),
    createdBy: PerformedBySchema.nullable(),
});
const facetsSchema = z.object({
    byType: z.record(z.enum(DocumentTypes), z.number().int()),
    byContentType: z.record(z.string(), z.number().int()),
    signed: z.number().int(),
    foundations: z.number().int(),
});
const inputSchema = searchInputSchema(filtersSchema);
const outputSchema = searchEnvelopeSchema(itemSchema, facetsSchema);
export const searchDocumentsTool = {
    name: ToolName.SearchDocuments,
    category: ToolCategory.Documents,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: "List documents on this case (foundations, judgements, settlements, court papers, etc.). Returns domain metadata plus the underlying fileId — call get_file with the fileId to read the document's extracted text.",
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=search-documents.js.map